import { api } from '../../../configuration'
import { postRestRequest } from '../../../helpers/RestHelpers'
import { getStrapiCreateResponseEntryId } from '../../../helpers/strapiRest'

export type AddParams = {
  data: { [key: string]: any }
}

const add = ({ data }: AddParams) => {
  return postRestRequest({
    url: api.REST_API_URL + `/classified-answers`,
    data: { data },
    transformer: (response: any) => {
      return response?.data?.id ?? getStrapiCreateResponseEntryId(response)
    },
  })
}

export default add
